import { useSelector } from 'react-redux';
import { getAttachmentsStatus } from '../../selectors';
import { Media } from '../../components-v4/media';
import { useFiles } from './hooks/use-files';
import { FilesContent, FilesDraftDialog } from './ui';
import { HStack, Skeleton } from '../../components-v4';

type FilesProps = {
  /** Можно ли добавлять файлы (кнопка загрузки и диалог). Список показывается всегда */
  canAdd?: boolean;
};

export const Files = ({ canAdd = false }: FilesProps) => {
  const attachmentsStatus = useSelector(getAttachmentsStatus);

  const {
    committedFiles,
    setCommittedFiles,
    handleCommit,
    uploadStatus,
    draftFiles,
    handleDraftChange,
    dialogOpen,
    handleDiscard,
  } = useFiles();

  if (attachmentsStatus === 'loading') {
    return (
      <HStack spacing="xs" style={{ overflow: 'auto' }}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton
            key={index}
            style={{
              minWidth: 180,
              minHeight: 240,
            }}
          />
        ))}
        <Skeleton />
      </HStack>
    );
  }

  if (!canAdd && !committedFiles.length) {
    return null;
  }

  return (
    <>
      <Media.Root
        initialItems={committedFiles}
        onItemsChange={setCommittedFiles}
      >
        <FilesContent
          canAdd={canAdd}
          committedFilesLength={committedFiles.length}
          draftFiles={draftFiles}
          onDraftChange={handleDraftChange}
        />
      </Media.Root>

      {canAdd && (
        <FilesDraftDialog
          open={dialogOpen}
          committedFilesLenght={committedFiles.length}
          draftFiles={draftFiles}
          onDraftChange={handleDraftChange}
          onCommit={handleCommit}
          uploadStatus={uploadStatus}
          onDiscard={handleDiscard}
        />
      )}
    </>
  );
};
